import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const cockpitDashboardWidgets = makeDynamicConfigWidgets([
  {
    name: 'cockpitWelcome',
    cols: 8,
    props: {
      showPropertyDetails: true,
      showConsultantAvailability: true,
    },
  },
  {
    name: 'cockpitExpose',
    cols: 4,
    props: {
      showPropertyImages: true,
      showPropertySpecs: true,
    },
  },
  {
    name: 'cockpitAdViews',
    cols: 4,
    props: {
      title: 'cockpit_ad_views_widget_title',
      text: 'cockpit_ad_views_widget_text',
      infoText: 'cockpit_ad_views_widget_info_text',
      showTrend: true,
      showComparison: true,
      showLastUpdated: true,
    },
  },
  {
    name: 'cockpitDigitalTour',
    cols: 4,
    props: {
      title: 'cockpit_digital_tour_widget_title',
      text: 'cockpit_digital_tour_widget_text',
      infoText: 'cockpit_digital_tour_widget_info_text',
      showTrend: true,
      showComparison: true,
      showLastUpdated: true,
    },
  },
  {
    name: 'cockpitExposeDownloads',
    cols: 4,
    props: {
      title: 'cockpit_expose_downloads_widget_title',
      text: 'cockpit_expose_downloads_widget_text',
      infoText: 'cockpit_expose_downloads_widget_info_text',
      showTrend: true,
      showComparison: true,
      showLastUpdated: true,
    },
  },
  {
    name: 'cockpitBookedVisits',
    cols: 4,
    props: {
      title: 'cockpit_booked_visits_widget_title',
      text: 'cockpit_booked_visits_widget_text',
      infoText: 'cockpit_booked_visits_widget_info_text',
      showNumbersBreakdown: true,
      showLastUpdated: true,
    },
  },
  {
    name: 'cockpitCalendarEventsWidget',
    cols: 8,
    props: {
      title: 'cockpit_calendar_events_widget_title',
      showUpcoming: true,
      showPast: true,
      showBookedVsAvailable: true,
    },
  },
  {
    name: 'cockpitInterestedBuyers',
    cols: 4,
    props: {
      title: 'cockpit_interested_buyers_widget_title',
      text: 'cockpit_interested_buyers_widget_text',
      infoText: 'cockpit_interested_buyers_widget_info_text',
      showTrend: true,
      showNumbersBreakdown: true,
      showLastUpdated: true,
    },
  },
  {
    name: 'cockpitOffers',
    cols: 4,
    props: {
      title: 'cockpit_offers_widget_title',
      text: 'cockpit_offers_widget_text',
      infoText: 'cockpit_offers_widget_info_text',
      showTrend: true,
      showPriceRange: true,
      showLastUpdated: true,
    },
  },
  {
    name: 'cockpitActivities',
    cols: 8,
    props: {
      infoText: 'cockpit_activities_widget_info_text',
      showRecentActivity: true,
      showActivityTypes: true,
      showPersonDetails: true,
    },
  },
]);
